import { useCallback, useMemo } from "react"

import { Flex, Space } from "antd"

import ExportDropdown from "../../Components/Export"
import Filters from "../../Components/Filters"
import ManageColumn from "../../Components/ManageColumns"
import Table from "../../Components/Table"
import { AddCommentModal } from "./components/AddCommentModal"
import { ChangeStatusModal } from "./components/ChangeStatusModal"
import {
  allFilters,
  exportItems,
  PAGE_SIZE,
  pinnedColumns,
  useCreditsAutomationPage
} from "./hooks/useCreditsAutomationPage"

import styles from "./styles.module.less"

const CreditsAutomationPage = () => {
  const {
    isMobile,
    results,
    count,
    fetching,
    filters,
    visibleFilters,
    handleChangeFilter,
    handleClearFilters,
    isFiltersDefault,
    filterOptions,
    handleExport,
    exportFetching,
    myColumns,
    setMyColumns,
    tableColumns,
    pageNumber,
    setPageNumber,
    setOrdering,
    changeStatusRecord,
    handleCloseStatusModal,
    handleApproveStatusChange,
    reasonOptions,
    updateStatusFetching,

    commentRecord,
    handleCloseCommentModal,
    handleSaveComment,
    addCommentFetching
  } = useCreditsAutomationPage()

  const tableScroll = useMemo(() => {
    const viewportHeight = window.innerHeight
    const fixedPixels = 72 + 24 + 32 + 24 + 43 + (16 + 32 + 16) + 16
    return { x: "max-content", y: viewportHeight - fixedPixels }
  }, [])

  const handleChangeTable = useCallback(
    (pagination, _tableFilters, sorter) => {
      let ordering = null
      if (sorter?.order) {
        ordering = sorter.order === "ascend" ? sorter.field : `-${sorter.field}`
      }
      setPageNumber(pagination.current)
      setOrdering(ordering)
    },
    [setPageNumber, setOrdering]
  )

  return (
    <div className={styles.page}>
      <Flex
        gap={16}
        align="center"
        justify="space-between"
        className={styles.filtersRow}
        style={isMobile ? { flexDirection: "column", alignItems: "flex-start" } : undefined}
      >
        <Filters
          visibleFilters={visibleFilters}
          filterOptions={filterOptions}
          allFilters={allFilters}
          filtersType="credits_automation"
          filters={filters}
          onChangeFilter={handleChangeFilter}
          showClearBtn={!isFiltersDefault}
          onClearFilters={handleClearFilters}
          isMobile={isMobile}
        />

        <Space style={{ flexShrink: 0 }}>
          <ExportDropdown
            loading={exportFetching}
            onExport={handleExport}
            isAdmin
            items={exportItems}
          />
          <ManageColumn
            pinnedColumns={pinnedColumns}
            myColumns={myColumns}
            onChangeColumns={setMyColumns}
            dataTour="credits-automation-table-manage-columns"
          />
        </Space>
      </Flex>

      <Table
        className={styles.table}
        columns={tableColumns}
        loading={fetching}
        dataSource={results}
        rowKey="id"
        scroll={tableScroll}
        onChange={handleChangeTable}
        pagination={{ total: count, current: pageNumber, pageSize: PAGE_SIZE }}
        showSizeChanger={false}
      />

      <ChangeStatusModal
        open={!!changeStatusRecord}
        onCancel={handleCloseStatusModal}
        onApprove={handleApproveStatusChange}
        loading={updateStatusFetching}
        reasonOptions={reasonOptions}
      />

      <AddCommentModal
        open={!!commentRecord}
        onCancel={handleCloseCommentModal}
        onApprove={handleSaveComment}
        initialComment={commentRecord?.comments}
        loading={addCommentFetching}
      />
    </div>
  )
}

export default CreditsAutomationPage
